import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import GetMyUser from '../../q/GetMyUser';
import UpdateUser from '../../q/UpdateUser';
import { AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
// import withContext from '../../context';
// class UserData extends React.Component {
//   constructor(props) {
//     super(props);
//   }

//   // getUserData() {
//   //   return this.props.userData;
//   // }

//   // updateUserData() {
//   //   return this.props.updateUserData;
//   // }

//   // onUpdateUser() {
//   //   return this.props.onUpdateUser;
//   // }

//   render() {
//     const { context } = this.props;
//     context.userData = this.props.userData;
//     context.updateUserData = this.props.updateUserData;
//     context.onUpdateUser = this.props.onUpdateUser;
//     return (<></>);
//   }
// }

export default (Comp) => compose(
  graphql(GetMyUser, {
    skip: (props) => !props.user,
    props: (props) => { // eslint-disable-line arrow-body-style
      // console.log('GetUser');
      // console.log(props);

      return {
        // ...props,
        userData: props.data.getMyUsers,
        updateUserData: props.data.refetch,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.user.attributes.sub,
      },
      client: AppSyncClientAuthenticated(props.user),
      fetchPolicy: 'cache-and-network',
    }),
  }),
  graphql(UpdateUser, {
    props: (props) => ({
      onUpdateUser:
        (args) => {
          const {
            uuid, name, desc, image, langs, locale,
            payout,
            payoutPayPalEmail,
          } = args;

          console.log('args');
          console.log(args);
          console.log('uuid');
          console.log(uuid);
          return props.mutate({
            variables: {
              uuid,
              name,
              desc,
              image,
              langs,
              locale,
              payout,
              payoutPayPalEmail,
            },
            // optimisticResponse: () => {
            //   const result = {
            //     uuid,
            //     name,
            //     desc,
            //     image,
            //     langs,
            //   };
            //   result['__typename'] = 'Users'; // eslint-disable-line dot-notation
            //   return {
            //     updateUsers: result,
            //     getMyUsers: result,
            //   };
            // },
          });
        },
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyUser,
        variables: { uuid: props.user && props.user.attributes.sub },
      }],
      awaitRefetchQueries: true,
      fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(Comp);
